/**
 * Visibilité des sections fiche produit — Lot L-UX-1 (étape 1).
 */

import { ALL_PRODUCT_SECTION_KEYS, PRODUCT_SECTION_LABELS } from '../config/produitSectionKeys.js';
import { ARCHETYPE_IDS, getArchetypeById } from '../config/produitArchetypes.js';

/**
 * @typedef {Object} SectionVisibilityResult
 * @property {string[]} visible
 * @property {string[]} optional
 * @property {string[]} hidden
 * @property {string[]} rendered — visible + optional (+ hidden si advancedMode)
 */

/**
 * @param {string} archetypeId
 * @param {{ advancedMode?: boolean, includeOptional?: boolean }} [options]
 * @returns {SectionVisibilityResult}
 */
export function getSectionVisibility(archetypeId, options = {}) {
  const { advancedMode = false, includeOptional = false } = options;
  const archetype = getArchetypeById(archetypeId);

  if (!archetype) {
    return {
      visible: [],
      optional: [],
      hidden: ALL_PRODUCT_SECTION_KEYS,
      rendered: [],
    };
  }

  if (archetypeId === ARCHETYPE_IDS.AVANCE) {
    const visible = [...archetype.sections.visible];
    return {
      visible,
      optional: [],
      hidden: [],
      rendered: visible,
    };
  }

  const visible = [...archetype.sections.visible];
  const optional = [...(archetype.sections.optional ?? [])];
  const hidden = [...(archetype.sections.hidden ?? [])];

  let rendered = [...visible];
  if (includeOptional) {
    rendered = [...rendered, ...optional];
  }
  if (advancedMode) {
    rendered = [...new Set([...rendered, ...hidden])];
  }

  return { visible, optional, hidden, rendered };
}

/**
 * @param {string} archetypeId
 * @param {string} sectionKey
 * @param {{ advancedMode?: boolean, enrichMode?: boolean }} [options]
 */
export function isSectionRendered(archetypeId, sectionKey, options = {}) {
  const { advancedMode = false, enrichMode = false } = options;
  const { visible, optional, hidden } = getSectionVisibility(archetypeId);

  if (visible.includes(sectionKey)) return true;
  if (enrichMode && optional.includes(sectionKey)) return true;
  if (advancedMode && hidden.includes(sectionKey)) return true;
  return false;
}

/** Nombre de sections visibles par défaut (hors AVANCE). */
export function countDefaultVisibleSections(archetypeId) {
  return getSectionVisibility(archetypeId).visible.length;
}

/** Libellés commerçant pour récap écran 3. */
export function getVisibleSectionLabels(archetypeId) {
  const { visible } = getSectionVisibility(archetypeId);
  return visible.map((key) => PRODUCT_SECTION_LABELS[key] ?? key);
}

export function getHiddenSectionLabels(archetypeId) {
  const { hidden } = getSectionVisibility(archetypeId);
  return hidden.map((key) => PRODUCT_SECTION_LABELS[key] ?? key);
}
